import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConnectIntegrationsComponent } from './connect-integrations.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ConnectIntegrationsComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class ConnectIntegrationsRoutingModule {}
